var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.innerValue.isCreateQuote,
              expression: "innerValue.isCreateQuote",
            },
          ],
          staticClass: "is-checkradio",
          attrs: { id: "create", type: "radio", name: "create" },
          domProps: {
            value: true,
            checked: _vm._q(_vm.innerValue.isCreateQuote, true),
          },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.innerValue, "isCreateQuote", true)
            },
          },
        }),
        _c("label", { attrs: { for: "create" } }, [_vm._v("Create New Quote")]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.innerValue.isCreateQuote,
              expression: "innerValue.isCreateQuote",
            },
          ],
          staticClass: "is-checkradio",
          attrs: { id: "assign", type: "radio", name: "assign" },
          domProps: {
            value: false,
            checked: _vm._q(_vm.innerValue.isCreateQuote, false),
          },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.innerValue, "isCreateQuote", false)
            },
          },
        }),
        _c("label", { attrs: { for: "assign" } }, [_vm._v("Assign Quote")]),
      ]),
    ]),
    (_vm.ecomType.toLowerCase() === "orm" ||
      _vm.ecomType.toLowerCase() === "audanet") &&
    !_vm.innerValue.isCreateQuote
      ? _c(
          "div",
          [
            _c("load-quote-assign", {
              attrs: { "rego-no": _vm.value.regoNo, "ecom-type": _vm.ecomType },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.ecomType === "pnet" && !_vm.innerValue.isCreateQuote
      ? _c("div", [
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.quoteNo,
                  expression: "quoteNo",
                },
                { name: "focus-inserted", rawName: "v-focus-inserted" },
              ],
              staticClass: "input is-uppercase",
              class: { "is-danger": !_vm.validQuoteNo },
              attrs: { placeholder: "Quote No." },
              domProps: { value: _vm.quoteNo },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.quoteNo = $event.target.value
                  },
                  _vm.searchQuote,
                ],
              },
            }),
          ]),
          _vm.validQuoteNo &&
          _vm.$v.loadOptions.quoteId.$dirty &&
          !_vm.quoteIsAuthorised &&
          !_vm.checkingQuoteIsAuthorised
            ? _c("span", { staticClass: "help is-success" }, [
                _vm._v("Valid Quote No."),
              ])
            : _vm._e(),
          !_vm.validQuoteNo &&
          !_vm.quoteIsAuthorised &&
          !_vm.checkingQuoteIsAuthorised
            ? _c(
                "span",
                { staticClass: "has-text-danger is-flex align-items-center" },
                [_vm._m(0), _vm._v(" Please enter an existing Quote No. ")]
              )
            : _vm._e(),
          _vm.quoteIsAuthorised && !_vm.checkingQuoteIsAuthorised
            ? _c(
                "span",
                { staticClass: "has-text-danger is-flex align-items-center" },
                [_vm._m(1), _vm._v(" This quote has been authorised already. ")]
              )
            : _vm._e(),
          _vm.checkingQuoteIsAuthorised
            ? _c(
                "span",
                { staticClass: "has-text-warning is-flex align-items-center" },
                [_vm._m(2), _vm._v(" Checking Quote... ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-warning" }, [
      _c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-20px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }